export default "__VITE_ASSET__BlBfB28Z__"